'use client'

import { faClone } from '@fortawesome/pro-solid-svg-icons'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import FeatureBadgeSlot from '@/components/FeatureBadgeSlot'
import { useCompareBadgeProps } from '@/components/listings/compare/compareAnalytics'
import { useCompareSelection } from '@/components/listings/compare/CompareSelectionProvider'
import { FeatureFlags } from '@/helpers/featureFlags'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

import { FiltersButton, FiltersIcon } from '../../shared/listings-ui'

// The pill sits beside the toggle, never inside it (a button in a button), and
// never wraps away from it
const ToggleWithBadge = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`

export const CompareToggleButton = () => {
  const { formatMessage } = useIntl()
  const { trackButtonClicked } = useAnalytics()
  const accountId = useDecodedAccessToken()?.accountId
  const isCompareEnabled = useFlag(FeatureFlags.ENABLE_ALP_COMPARE_LISTINGS)
  const { compareMode, toggleCompareMode } = useCompareSelection()
  const badgeProps = useCompareBadgeProps()

  if (!accountId || !isCompareEnabled) return null

  const handleToggle = () => {
    trackButtonClicked({
      buttonName: 'compare_listings_toggle',
      is_selected: !compareMode,
      ...badgeProps(),
    })
    toggleCompareMode()
  }

  const label = compareMode
    ? formatMessage({ id: 'Listings.ListView.compareMode.exit' })
    : formatMessage({ id: 'Listings.ListView.compareMode.enter' })

  // The Slot reads the badge flag, so it renders only past the gate above
  return (
    <ToggleWithBadge>
      <FiltersButton
        appearance={compareMode ? 'primary' : 'secondary'}
        onClick={handleToggle}
      >
        <FiltersIcon icon={faClone} />
        <span>{label}</span>
      </FiltersButton>
      <FeatureBadgeSlot featureKey="compare_listings" />
    </ToggleWithBadge>
  )
}
